/**
 * TODO будет перенесено в утилиты и покрыто тестами в https://cianru.atlassian.net/browse/CD-38432
 */
interface IObject {
  // oxlint-disable-next-line typescript/no-explicit-any
  [key: string]: any;
}

export function shallowEqual(first: IObject, second: IObject): boolean {
  const firstKeys = Object.keys(first);
  const secondKeys = Object.keys(second);
  const sameKeysCount = firstKeys.length === secondKeys.length;

  return (
    sameKeysCount &&
    firstKeys.every((key: string) => {
      return first[key] === second[key];
    })
  );
}
